// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-settings-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 15px 24px 14px 24px;
  height: 58px;
  box-sizing: border-box;
}

.room-settings-header-title {
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.36em;
  color: #434343;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 80px);
}

.room-settings-header-close {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  background: #4A4A4A;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #FFFFFF;
  padding-bottom: 5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.room-settings-header-close:hover {
  background: #333333;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,2FAA2F;EAC3F,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".room-settings-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 15px 24px 14px 24px;\n  height: 58px;\n  box-sizing: border-box;\n}\n\n.room-settings-header-title {\n  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: 1.36em;\n  color: #434343;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: calc(100% - 80px);\n}\n\n.room-settings-header-close {\n  position: absolute;\n  right: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #4A4A4A;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #FFFFFF;\n  padding-bottom: 5px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.room-settings-header-close:hover {\n  background: #333333;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
